import { Controller } from "stimulus";
import { EventCurrencyChanged } from "../events";
import { EventPriceLoaded } from "../events";
import { reloadBootstrapTooltip } from "../util/tooltip";

export default class extends Controller {
  static targets = ["moreFilters", "tableContainer", "table", "tab", "paginate", "displayUnconvertDataSwitch", "paginatedShowMoreTbody", "showMore", "loading", "tableSearchFilter"];

  connect() {
    if(this.hasPaginatedShowMoreTbodyTarget){
      this.page = 0;
      this.perPage = 100;
      this.rowCount = this.paginatedShowMoreTbodyTarget.children.length;
      // Hide button if first page not full
      var hasMoreToLoad = this.rowCount == this.perPage;
      this._showButton(hasMoreToLoad);
    }
    this.defaultView = this.tableContainerTarget.getAttribute("data-default-view");

    this.queryString = window.location.search
    this.currentView = (new URLSearchParams(this.queryString)).get("view");
    if (this.currentView === null) {
      this.currentView = "market"
    }

    Promise.all([
      import("tablesort")
    ]).then( res => [
      res[0],
      import("tablesort/src/sorts/tablesort.number")
    ]).then(res => {
      window.Tablesort = res[0].default;
      //set multiple table use Tablesort in en/derivatives page
      this.tableTargets.forEach((target) => {
        new Tablesort(target, {
          descending: true
        });
      });

      this.tableTarget.addEventListener("afterSort", () => {
        const c = this.tableTarget.querySelectorAll(
          'th[aria-sort="ascending"],th[aria-sort="descending"]'
        );
        const ele = c[0];
        const idx = ele.cellIndex;

        this.tableTarget.querySelectorAll("tr").forEach(function(tr) {
          tr.querySelectorAll("td").forEach(function(td) {
            td.classList.remove("table-active");
            if (td.cellIndex == idx) {
              td.classList.add("table-active");
            }
          });
        });
      });

    });

    // this.triggerFloatThead();

    if (document.cookie.split(";").includes("displayUnconvertData=true")) {
      this.displayUnconvertDataSwitchTarget.checked = true;
      this.displayUnconvertedData();
    }
  }

  toggleMoreFilters() {
    this.moreFiltersTarget.classList.toggle("d-none");
  }

  executeFilter(event) {
    var hashing_algorithm = event.target.getAttribute("data-hashing-algorithm");
    var category_id = event.target.getAttribute("data-category-id");
    var asset_platform_id = event.target.getAttribute("data-asset-platform-id");

    var searchParams = new URLSearchParams("");
    if (hashing_algorithm != null) {
      searchParams.append("hashing_algorithm", hashing_algorithm);
    } else {
      searchParams.delete("hashing_algorithm");
    }
    if (category_id != null) {
      searchParams.append("category_id", category_id);
    } else {
      searchParams.delete("category_id");
    }
    if (asset_platform_id != null) {
      searchParams.append("asset_platform_id", asset_platform_id);
    } else {
      searchParams.delete("asset_platform_id");
    }

    var view = this.currentView;
    searchParams.delete("view");
    searchParams.append("view", view);

    window.location.search = searchParams.toString();
  }

  /* Triggers */
  triggerFloatThead() {
    this._tableHeadLibPromise =
      this._tableHeadLibPromise ||
      new Promise(resolve => {
        // not so important, delay a bit
        setTimeout(() => {
          loadScript(
            "https://cdnjs.cloudflare.com/ajax/libs/floatthead/2.1.2/jquery.floatThead.js",
            resolve
          );
        }, 500);
      });

    this._tableHeadLibPromise.then(() => {
      const $table = $(this.tableTarget);

      window.requestAnimationFrame(() => {
        $table.floatThead("destroy");
        $table.floatThead({ position: "absolute" });
      });
    });
  }

  updatePagination() {
    var paginateLinks = this.paginateTarget.querySelectorAll("li a");
    for (let link of paginateLinks) {
      var href = link.getAttribute("href");
      if (href != null) {
        var view = this.currentView;
        link.setAttribute("href", this.transformUrl(href, view, false));
      }
    }
  }

  /* Helper Methods */
  url(view) {
    return this.transformUrl(window.location.href, view, true);
  }

  transformUrl(urlString, view, withRoot) {
    let url;
    if (withRoot) {
      url = new URL(urlString);
    } else {
      url = new URL(urlString, window.location.origin);
    }

    const searchParams = url.searchParams;
    searchParams.delete("view");
    if (view !== this.defaultView) {
      searchParams.append("view", view);
    }

    const query = searchParams.toString();
    let path = window.location.pathname;
    if (query) {
      path += "?" + query;
    }
    return window.location.origin + path;
  }

  displayUnconvertedData(){
    let elements = document.getElementsByClassName("unconverted-data");
    if (this.displayUnconvertDataSwitchTarget.checked){
      document.cookie = "displayUnconvertData=true";
      for (let item of elements) {
        item.classList.remove("d-none");
      }
    } else {
      document.cookie = "displayUnconvertData=false";
      for (let item of elements) {
        item.classList.add("d-none");
      }
    }
  }

  filterTable(e){
    var value = this.tableSearchFilterTarget.value.toLowerCase()
    var tables = this.tableTargets
    var trs = []
    tables.forEach(function(table) { 
      for(let tr of table.getElementsByTagName("tbody")[0].getElementsByTagName("tr")){
        trs.push(tr) 
      }
    })
    $(trs).filter(function() {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });

    // Meant to target Derivatives ticker filtering to hide section
    tables.forEach(function(table) { 
      var table_trs = $(table.getElementsByTagName("tbody")[0].getElementsByTagName("tr"))

      if(table_trs.filter(function() { return $(this).css("display") == "none" }).length == table_trs.length){
        $(table).parents('.contract-table').hide()
      }else{
        $(table).parents('.contract-table').show()
      }
    });
  }

  showMore(e) {
    this._showButton(false);
    this._showSpinner(true);
    this.page += 1;

    fetch(
      `${this.showMoreTarget.dataset.url}?page=${this.page}&per_page=${this.perPage}`,
      { credentials: "same-origin" }
    )
      .then(response => response.text())
      .then(res => {
        if (res) {
          this.paginatedShowMoreTbodyTarget.insertAdjacentHTML("beforeend", res);

          this._showButton(true);
          this._showSpinner(false);
          reloadBootstrapTooltip();

          const newRowCount = this.paginatedShowMoreTbodyTarget.children.length;
          if (this.perPage > newRowCount - this.rowCount) {
            // Nothing more to load.
            this._showButton(false);
            this._showSpinner(false);
          }
          this.rowCount = newRowCount;
          // Incoming rows are in USD, we need to convert to target currency. Run price formatter.
          this.element.dispatchEvent(
            new CustomEvent(EventPriceLoaded, {
              bubbles: true
            })
          );
          const currencyCode = e.currentTarget.getAttribute("data-iso-code");
          // Dispatch currency changed event
          this.element.dispatchEvent(
            new CustomEvent(EventCurrencyChanged, {
              bubbles: true,
              detail: {
                currencyCode: currencyCode
              }
            })
          );
        } else {
          this._showButton(false);
          this._showSpinner(false);
        }
      });

    // Prevent hash from showing in URL
    e.preventDefault();
  }

  _showButton(show) {
    this.showMoreTarget.style.display = show ? "" : "none";
  }

  _showSpinner(show) {
    this.loadingTarget.style.display = show ? "" : "none";
  }
}
